module.exports = __webpack_public_path__ + "img/logo-dark.ac538dab.png";